import * as _ from 'underscore';

import Revisal from './Revisal';

export default class Bill {

    static bless( data: any ) {
        return ( data && new Bill(data.subtotal,
                                  data.total,
                                  _.map( data.revisals, Revisal.bless )) );
    }

    constructor( public subtotal: number,
                 public total: number,
                 public revisals: Revisal[] ) {
    }

    get roomRate(): number {
        return this.total - this.tax;
    }

    get tax(): number {
        return _.reduce( this.revisals, (c: number, r: Revisal) => c + ( r.tax ? r.amount : 0 ), 0 );
    }

}



/** WEBPACK FOOTER **
 ** ./src/models/Bill.ts
 **/